import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'CONTACT_UPDATE',
    smsDelete : 'CONTACT_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        summary_list: [],
        contact_list: [],

        submitSuccess: false,
        contactLoading: false,
        contactError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_SUMMARY_LIST(state, contact) {
            state.summary_list = contact;
        },

        SET_CONTACT(state, contact) {
            state.contact_list = contact;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        CONTACT_LOADING (state, loading) {
            state.contactLoading = loading;
        },

        CONTACT_ERROR (state, hasError) {
            state.contactError = hasError;
        }
    },

    actions: {
        async fetchOccupancySummary ({ commit }, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.shelter) params.append('shelter', payload.shelter);
                if (payload.current_date) params.append('current_date', payload.current_date);
                
                let url = V1API.occupancy_summary_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const response = result.data

                commit('SET_SUMMARY_LIST', response.data)
            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async addContact ({commit, dispatch}, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_contact, payload.contact, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchContact')
                return response

            } catch (e) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async fetchContact ({ commit }) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.contact_list, config);
                let response = result.data
                commit('SET_CONTACT', response.data);

            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async filterContacts ({ commit }, payload) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try { 
                let params = new URLSearchParams();
        
                if (payload.shelter) params.append('shelter', payload.shelter);
                if (payload.type) params.append('type', payload.type);
                
                let url = V1API.contact_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const response = result.data

                commit('SET_CONTACT', response.data);

            } catch(error) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },

        async updateContact ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_contact + payload.id, payload.contact, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchContact')
                return response

            } catch (e) {
                commit('CONTACT_ERROR', true);
            } finally {
                commit('CONTACT_LOADING', false);
            }
        },
        
        async deleteContact({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.contact_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchContact')
            return response
        }
    },

    getters: {}
}
